<template>
    <el-dialog
        :title="fileData.materialFullName"
        :model-value="visible"
        :close-on-click-modal="false"
        :width="playerConf.width+40"
        @close="handleClose"
        destroy-on-close
        class="mater-dialog"
    >
        <MaterialResPlayer
            :material="props.fileData"
            withFullScreen
            :video-options="{
                autoplay: false,
                controlBar: {pictureInPictureToggle: false}
            }"
            downloadable
            :width="playerConf.width" 
        />
        <!-- :height="playerConf.height" -->
    </el-dialog>
</template>

<script setup lang="ts">
import {ElDialog} from 'element-plus';
import { MaterialResPlayer } from '@yanxiu/player';
import {reactive} from 'vue';

const props = defineProps({
    visible: {
        type: Boolean,
        default: false
    },
    fileData: {
        type: Object,
        default: () => ({})
    }
});
const emit = defineEmits(['update:visible']);

const COURSE_WIDTH = 900;
const COURSE_HEIGHT = 598;

let playerConf = reactive({
    width: COURSE_WIDTH,
    height: COURSE_HEIGHT
});

const handleClose = () => {
    emit('update:visible', false);
};
</script>
<style lang="scss">
.mater-dialog {
    height: 640px;
    .el-dialog__body {
        padding-top: 10px;
        .empty-wrapper {
            margin-top: 120px;
        }
    }
}
</style>
